import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-4">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">小蓝视频</span>
            <span className="mt-0.5 font-label text-[10px] tracking-[0.2em] text-foreground-500">GUIDE HUB</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="cursor-pointer text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-2-line text-sm" />
            </span>
            获取安装包
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-3 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-2-line text-sm" />
              </span>
              获取安装包
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}